import React from "react";
import "./RepresentanteText.css";

export default function RepresentanteText({ titulos, localizacao }) {

  const textos = titulos
    ?.filter(item => item.localizacao === localizacao)
    .sort((a, b) => a.ordem - b.ordem);

  return (
    <section className="representante-text">
      {textos && textos.length > 0 ? (
        textos.map(item => (
          <h1 key={item.id}>{item.descricao}</h1>
        ))
      ) : (
        <>
          <h1>Nós estamos a espera de você.</h1>
          <h1>para que juntos, possamos expandir.</h1>
        </>
      )}
    </section>
  );
}
